import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async (id) => {
  const endpoint = `${apiEndpoints.sites}/${id}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.delete(URL, { withCredentials: true }))
}
